import "../../css/LoginPage.css"
import "../../css/LoginMobilePage.css"
import proxy from "../../utils/Proxy";
import { useState } from "react"
import { pressEnter } from "../../utils/Utils"
import { useMediaQuery } from "react-responsive";

let LoginPage = (props) => {
    let [statusMessage, setStatusMessage] = useState("계속하려면 로그인해주세요.")

    // 로그인 페이지는 기존의 디자인을 변경하기 어려워서
    // css상의 미디어 쿼리를 사용하는 대신 useMediaQuery 훅을 이용해서
    //모바일과 pc/tablet에서 각각 다른 화면 렌더링.
    let isMobile = useMediaQuery({ maxWidth: 768 })

    return (isMobile ? <div className="mobile-login-form-container">
        <div className="mobile-login-header">
            <div className="mobile-login-logo"></div>
            <p className="mobile-login-status">{statusMessage}</p>
        </div>
        <div className="login-box-container">
            <LoginForm onLoginChange={props.onLoginChange}
                onStatusMessageChange={setStatusMessage.bind(this)}></LoginForm>
        </div>
        <div className="login-footer-container">
            <div className="login-footer">
                <div className="contact-container">
                    <a target="_blank" rel="noreferrer" href='https://pianotogether.co.kr/' className="contact-icon" id="home">&nbsp;</a>
                    <a target="_blank" rel="noreferrer" href="https://www.instagram.com/pianotogether2/" className="contact-icon" id="instagram">&nbsp;</a>
                    <a target="_blank" rel="noreferrer" href="https://www.youtube.com/@pianotogether_official" className="contact-icon" id="youtube">&nbsp;</a>
                </div>
            </div>
        </div>
    </div> : <div className="login-form-container">
        <div className="login-form">
            <div className="login-left-container">
                <div className="login-information-container">
                    <div className="login-information">
                        <div className="login-logo-container">
                            <p>Pianotogether</p>
                        </div>
                        <hr className="logo-divider"></hr>
                        <div className="logo-text">
                            <p className="login-subtitle">성인전문 피아노학원</p>
                            <p className="login-description">{statusMessage}</p>
                        </div>
                        <div className="login-footer-container">
                            <div className="login-footer">
                                <div className="contact-container">
                                    <a target="_blank" rel="noreferrer" href='https://pianotogether.co.kr/' className="contact-icon" id="home">&nbsp;</a>
                                    <a target="_blank" rel="noreferrer" href="https://www.instagram.com/pianotogether2/" className="contact-icon" id="instagram">&nbsp;</a>
                                    <a target="_blank" rel="noreferrer" href="https://www.youtube.com/@pianotogether_official" className="contact-icon" id="youtube">&nbsp;</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="right-container">
                <div className="login-box-container">
                    <LoginForm onLoginChange={props.onLoginChange}
                        onStatusMessageChange={setStatusMessage.bind(this)}></LoginForm>
                </div>
            </div>
        </div>
    </div>)
}
let LoginForm = (props) => {
    let onClick = () => {
        let body = {}
        body.loginid = document.getElementById("loginid").value
        body.password = document.getElementById("password").value
        body.isAdmin = document.getElementById("isAdmin").checked
        if (!body.loginid)
            return alert("아이디를 입력하세요.")
        else if (!body.password)
            return alert("비밀번호를 입력하세요.")
        proxy.post("/api/login", body).then((res) => {
            props.onLoginChange(typeof res.data.userid === "undefined")
        }).catch((error) => {
            let message = error.response.data.message
            props.onStatusMessageChange(message)
        });
    }
    let onDescriptionClick = (_) => {
        let isAdmin = document.getElementById("isAdmin")
        isAdmin.checked = !isAdmin.checked;
    }

    return (
        <div className="login-box">
            <div className="login-textbox-area">
                <input className="login-textbox" id="loginid" placeholder="아이디" type="text"
                    onKeyDown={(e) => pressEnter(e, onClick)}></input>
            </div>
            <div className="login-textbox-area">
                <input className="login-textbox" id="password" placeholder="패스워드" type="password"
                    onKeyDown={(e) => pressEnter(e, onClick)}></input>
            </div>
            <div className="login-checkbox">
                <input className="login-checkbox-admin" id="isAdmin" type="checkbox"
                    onKeyDown={(e) => pressEnter(e, onDescriptionClick)}></input>
                <p className="login-checkbox-admin-description" onClick={onDescriptionClick}>관리자 로그인</p>
            </div>
            <div className="login-button-area">
                <div className="login-button" tabIndex={0} onClick={onClick}
                    onKeyDown={(e) => pressEnter(e, onClick)}></div>
            </div>
        </div>
    )
}
export default LoginPage;